import { render, staticRenderFns } from "./RegWaNumberWithoutLogin.vue?vue&type=template&id=04c19c40&lang=pug"
import script from "./RegWaNumberWithoutLogin.vue?vue&type=script&lang=js"
export * from "./RegWaNumberWithoutLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports